


















import { Component, Watch } from 'vue-property-decorator'

import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'
import detail from '@/modules/Case/views/detail.vue'
import { Case } from '@/modules/Case/interfaces/case'

@Component({
  components: {
    AppSystemInfoCard
  }
})
export default class CaseDetailSource extends detail {
  sourceInfoCard = [
    { title: 'Source', content: '-' }
  ]

  mounted () {
    this.onCaseUpdated(this.caseInfo)
  }

  @Watch('caseInfo', { deep: true })
  onCaseUpdated (val: Case) {
    this.sourceInfoCard[0].content = val.source
      ? val.source.name
      : '-'
  }

  routeToProducerDetail () {
    return {
      name: 'ProducerDetailDetail',
      params: {
        id: this.caseInfo.source.id + ''
      }
    }
  }
}
